<template>
	<div ref="rootEl" class="c-health-check__content-head">
		<div v-if="props.tagLabel">
			<DsText html-element="p" text-type="label-md">
				{{ props.tagLabel }}
			</DsText>
		</div>
		<Transition name="fade" mode="out-in">
			<div
				v-if="props.showProgressBar || props.isPersonalInfoStep"
				class="c-health-check__actions"
			>
				<div
					v-if="
						props.showProgressBar &&
						!(props.isPersonalInfoStep || props.isConsentStep)
					"
					class="c-health-check__progress-bar"
				>
					<DsHcProgress
						:current-step="props.progressBarActiveIndex"
						:total-steps="props.questionLength"
						:status-text="progressBarText"
					></DsHcProgress>
				</div>
				<div v-if="props.isPersonalInfoStep || props.isConsentStep">
					<DsButton
						variant="link"
						iconEnd="button-navigate-forward"
						@click="handleSkip"
					>
						{{ props.skipSubmittingContactInfoLabel }}
					</DsButton>
				</div>
			</div>
		</Transition>
	</div>
</template>

<script setup lang="ts">
import { ref, computed } from 'vue';
import { DsHcProgress, DsButton, DsText } from '@coloplast/design-system';
import { track_opt_in_page_skip } from 'shared/services/tracking/healthCheckTrackingService';
import { interpolation } from 'shared/utils/interpolation';

interface ContentHeadProps {
	tagLabel: string;
	questionLength: number;
	progressbarText: string;
	progressBarActiveIndex: number;
	showProgressBar: boolean;
	isPersonalInfoStep: boolean;
	isConsentStep: boolean;
	skipSubmittingContactInfoLabel: string;
}

const props = defineProps<ContentHeadProps>();
const rootEl = ref<HTMLElement | null>(null);

const progressBarText = computed(() =>
	interpolation(props.progressbarText, {
		currentStep: props.progressBarActiveIndex,
		totalSteps: props.questionLength,
	}),
);

const emit = defineEmits(['skip']);

const handleSkip = () => {
	track_opt_in_page_skip();
	emit('skip');
};

defineExpose({
	rootEl,
});
</script>

<style scoped lang="scss">
@import 'multisite/styles/settings/settings';
@import 'multisite/styles/tools/tools';

.c-health-check {
	&__content-head {
		align-items: center;
		display: flex;
		gap: ds-space(9);
	}

	&__actions {
		margin-inline-start: auto;
	}

	&__progress-bar {
		width: min-content;
	}
}
</style>
